/* global YT */
import $ from 'jquery';

$(document).ready(function () {
  acfYtEmbedBlock();
});

function acfYtEmbedBlock() {
  $('.js-acf-yt-embed .js-acf-yt-embed__wrapper').on(
    'click',
    '.youtube-thumbnail',
    function (e) {
      const $thumbnail = $(this);
      const $wrapper = $thumbnail.closest('.js-acf-yt-embed__wrapper');
      const $block = $thumbnail.closest('.js-acf-yt-embed');

      const youtubeLink = $thumbnail.data('youtube-link');
      if (!youtubeLink) return;

      const youtubeIdMatch = youtubeLink.match(
        /(?:youtu\.be\/|youtube\.com\/(?:embed\/|watch\?v=))([\w-]{11})/
      );
      if (!youtubeIdMatch) return;
      const videoId = youtubeIdMatch[1];

      const embedUrl =
        'https://www.youtube.com/embed/' + videoId + '?autoplay=1&mute=1&rel=0';

      // Lightbox
      if ($block.hasClass('js-is-light-box')) {
        e.preventDefault();
        if (typeof $.fancybox !== 'undefined') {
          $.fancybox.open({
            src: embedUrl,
            type: 'iframe',
            opts: {
              iframe: { preload: false },
              smallBtn: true,
              toolbar: false,
              afterShow: function (instance, current) {
                current.$slide
                  .closest('.fancybox-container')
                  .addClass('acf-yt-lightbox');
              },
            },
          });
        }
        return;
      }

      // Hide thumbnail
      $thumbnail.hide();
      const $container = $wrapper.find('.acf-yt-embed__container');
      $container.show();

      // Height by img height
      const thumbnailHeight = $thumbnail.outerHeight();
      $container.css('height', thumbnailHeight + 'px');

      // Create unique container for API
      const playerId = 'yt-player-' + videoId;
      $container.html('<div id="' + playerId + '"></div>');

      function initPlayer() {
        if (typeof YT !== 'undefined' && YT.Player) {
          new YT.Player(playerId, {
            videoId: videoId,
            playerVars: { autoplay: 1, rel: 0 },
            events: {
              onReady: function (event) {
                event.target.playVideo();
                try {
                  event.target.unMute();
                } catch (e) {
                  // eslint-disable-next-line no-empty
                }

                setTimeout(() => {
                  const iframeEl = document
                    .getElementById(playerId)
                    .querySelector('iframe');
                  if (iframeEl) iframeEl.click();
                  // ІSet Iframe height = thumbnail
                  if (iframeEl) iframeEl.style.height = thumbnailHeight + 'px';
                }, 450);
              },
            },
          });
        } else {
          const iframe = $('<iframe>', {
            src: embedUrl,
            frameborder: 0,
            allow:
              'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
            allowfullscreen: true,
            css: {
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: thumbnailHeight + 'px',
            },
          });
          $container.append(iframe);
        }
      }

      if (typeof YT === 'undefined' || !YT.Player) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.body.appendChild(tag);

        window.onYouTubeIframeAPIReady = initPlayer;
      } else {
        initPlayer();
      }
    }
  );
}
